import React from 'react';
import { dataIt } from './api';

const STILI = {
  verde: 'bg-emerald-100 text-emerald-800',
  giallo: 'bg-amber-100 text-amber-800',
  rosso: 'bg-red-100 text-red-800',
  grigio: 'bg-gray-100 text-gray-600',
};

const Badge = ({ colore, testo, testid }) => (
  <span data-testid={testid} className={`inline-block text-xs font-medium px-2 py-0.5 rounded-full ${STILI[colore]}`}>{testo}</span>
);

export const BadgeCopia = ({ stato, testid }) => {
  if (!stato || stato.stato === 'sconosciuto') return null;
  if (stato.stato === 'annullato') return <Badge colore="grigio" testo="Annullato" testid={testid} />;
  if (stato.stato === 'ricevuta') {
    return <Badge colore={stato.in_ritardo ? 'giallo' : 'verde'} testid={testid}
      testo={`Copia firmata ricevuta il ${dataIt(stato.data)}${stato.in_ritardo ? ' (in ritardo)' : ''}`} />;
  }
  if (stato.stato === 'scaduta') return <Badge colore="rosso" testo={`Copia firmata NON arrivata (entro il ${dataIt(stato.scadenza)})`} testid={testid} />;
  return <Badge colore={stato.giorni_rimasti <= 15 ? 'giallo' : 'grigio'} testid={testid}
    testo={`Copia firmata attesa entro il ${dataIt(stato.scadenza)}`} />;
};

const statoScadenza = (scadenza) => {
  if (!scadenza) return 'mancante';
  const giorni = (new Date(`${scadenza}T12:00:00`) - new Date()) / 86400000;
  if (giorni < 0) return 'scaduta';
  return giorni <= 60 ? 'in_scadenza' : 'valida';
};

export const BadgeAutorizzazione = ({ scadenza, testid }) => {
  const s = statoScadenza(scadenza);
  if (s === 'mancante') return <Badge colore="giallo" testo="Scadenza da inserire" testid={testid} />;
  if (s === 'scaduta') return <Badge colore="rosso" testo={`SCADUTA il ${dataIt(scadenza)}`} testid={testid} />;
  return <Badge colore={s === 'in_scadenza' ? 'giallo' : 'verde'} testo={`Valida fino al ${dataIt(scadenza)}`} testid={testid} />;
};

const ESITI = {
  conforme: ['verde', 'Conforme'],
  attenzione: ['giallo', 'Vicino al limite'],
  non_conforme: ['rosso', 'Oltre il limite'],
};

export const BadgeEsito = ({ esito, testid }) => {
  if (!ESITI[esito]) return null;
  const [colore, testo] = ESITI[esito];
  return <Badge colore={colore} testo={testo} testid={testid} />;
};
